// prettier-ignore

import gsap from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'

gsap.registerPlugin(ScrollToPlugin)

function closeAllAccordions(accordions, clickedAccordion) {
  accordions.forEach((accordion) => {
    if (accordion === clickedAccordion) return // skip the clicked accordion

    const content = accordion.querySelector('[data-target="accordion-content"]')
    accordion.dataset.state = 'closed'
    gsap.to(content, { height: 0, autoAlpha: 0, duration: 0.5 })
    gsap.to(accordion.querySelector('.icon .plus-vertical'), {
      rotate: '0deg',
      transformOrigin: 'center',
      duration: 0.5,
    })
  })
}

function accordion() {
  const accordions = document.querySelectorAll('[data-target="accordion"]')

  if (!accordions) return

  closeAllAccordions(accordions, event.currentTarget.parentNode)

  accordions.forEach((accordion, index) => {
    const trigger = accordion.querySelector('[data-target="accordion-trigger"]')
    const content = accordion.querySelector('[data-target="accordion-content"]')

    trigger.addEventListener('click', (event) => {
      const { state } = accordion.dataset
      const clickedEl = event.currentTarget

      console.log('clickedEl', clickedEl.offsetTop)

      closeAllAccordions(accordions, event.currentTarget.parentNode)

      if (state === 'closed') {
        accordion.dataset.state = 'open'
        gsap.to(content, { height: 'auto', autoAlpha: 1, duration: 0.5 })
        gsap.to(accordion.querySelector('.icon .plus-vertical'), {
          rotate: '-90deg',
          transformOrigin: 'center',
          duration: 0.5,
          onComplete: () => {
            gsap.to(window, {
              duration: 0.5,
              scrollTo: {
                y: window.scrollY + clickedEl.getBoundingClientRect().top,
              },
            })
          },
        })
      } else {
        accordion.dataset.state = 'closed'
        gsap.to(content, { height: 0, autoAlpha: 0, duration: 0.5 })
        gsap.to(accordion.querySelector('.icon .plus-vertical'), {
          rotate: '0deg',
          transformOrigin: 'center',
          duration: 0.5,
        })
      }
    })
  })
}

export default accordion
